(function () {
  'use strict';

  function initSidebarMenu(root) {
    if (!root || root.dataset.heaNavReady === 'true') return;

    var rootPanel = root.querySelector('[data-sidebar-panel="root"]');
    var childPanels = Array.prototype.slice.call(root.querySelectorAll('.SidebarMenu__Panel--child'));
    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-sidebar-panel-target]'));
    var backButton = root.querySelector('[data-sidebar-back]');
    var brand = root.querySelector('[data-sidebar-brand]');
    var currentTitle = root.querySelector('[data-sidebar-current-title]');
    var closeButton = root.querySelector('[data-action="close-drawer"]');
    var activePanel = null;
    var activeTrigger = null;
    var rootScrollPosition = 0;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!rootPanel || !backButton || !brand || !currentTitle) return;

    root.dataset.heaNavReady = 'true';

    function moveSharedContent() {
      var brandSource = document.getElementById('HEA-sidebar-brand-source');
      var paseoSource = document.getElementById('HEA-sidebar-paseo-source');
      var paseoTarget = root.querySelector('#HEA-sidebar-paseo-target');

      if (brandSource && brandSource.firstElementChild) {
        brand.replaceChildren(brandSource.firstElementChild.cloneNode(true));
      }

      if (paseoSource && paseoSource.firstElementChild && paseoTarget) {
        paseoTarget.replaceChildren(paseoSource.firstElementChild.cloneNode(true));
      }
    }

    function focusAfterTransition(element, suppressFocusRing, delay) {
      if (suppressFocusRing) {
        element.classList.add('is-focus-silent');
        element.addEventListener('blur', function clearSilentFocus() {
          element.classList.remove('is-focus-silent');
        }, { once: true });
      }

      window.setTimeout(function () {
        element.focus({ preventScroll: true });
      }, reducedMotion ? 0 : delay);
    }

    function openPanel(trigger, suppressFocusRing) {
      var panel = root.querySelector('#' + trigger.getAttribute('data-sidebar-panel-target'));
      if (!panel) return;

      rootScrollPosition = rootPanel.scrollTop;
      activePanel = panel;
      activeTrigger = trigger;

      triggers.forEach(function (item) {
        item.setAttribute('aria-expanded', item === trigger ? 'true' : 'false');
      });

      rootPanel.setAttribute('aria-hidden', 'true');
      rootPanel.inert = true;
      childPanels.forEach(function (item) {
        var isActive = item === panel;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        item.inert = !isActive;
      });

      panel.scrollTop = 0;
      currentTitle.textContent = panel.getAttribute('data-sidebar-panel');
      currentTitle.hidden = false;
      brand.hidden = true;
      backButton.hidden = false;
      root.classList.add('is-panel-open');
      focusAfterTransition(backButton, suppressFocusRing, 0);
    }

    function returnToRoot(options) {
      var settings = options || {};
      var triggerToRestore = activeTrigger;

      triggers.forEach(function (item) {
        item.setAttribute('aria-expanded', 'false');
      });
      childPanels.forEach(function (item) {
        item.classList.remove('is-active');
        item.setAttribute('aria-hidden', 'true');
        item.inert = true;
      });

      rootPanel.removeAttribute('aria-hidden');
      rootPanel.inert = false;
      currentTitle.hidden = true;
      currentTitle.textContent = '';
      brand.hidden = false;
      backButton.hidden = true;
      root.classList.remove('is-panel-open');
      rootPanel.scrollTop = rootScrollPosition;
      activePanel = null;
      activeTrigger = null;

      if (settings.restoreFocus && triggerToRestore) {
        focusAfterTransition(triggerToRestore, settings.suppressFocusRing, 460);
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        openPanel(trigger, event.detail !== 0);
      });
    });

    backButton.addEventListener('click', function (event) {
      returnToRoot({ restoreFocus: true, suppressFocusRing: event.detail !== 0 });
    });

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        if (activePanel) returnToRoot();
      });
    }

    new MutationObserver(function () {
      if (root.getAttribute('aria-hidden') === 'true' && activePanel) returnToRoot();
    }).observe(root, { attributes: true, attributeFilter: ['aria-hidden'] });

    moveSharedContent();
  }

  function initAll() {
    initSidebarMenu(document.getElementById('sidebar-menu'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
